import { Box, Button, CircularProgress, SxProps, Theme } from '@mui/material';
import { capitalize } from '@warden-ui/common';

interface CPButtonProps {
  label: string;
  variant?: "text" | "outlined" | "contained" | undefined;
  loading?: boolean;
  disabled?: boolean;
  maxWidth?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const CPButton = ({
  label,
  variant = "contained",
  loading = false,
  disabled = false,
  maxWidth = true,
  ...props
}: CPButtonProps) => {
  const width = maxWidth ? 'w-100' : '';

  return (
    <Box className={width} sx={{ position: "relative" }}>
      <Button
        className={width}
        type="submit"
        variant={variant}
        color="primary"
        disabled={disabled || loading}
        onClick={props.onClick}
        sx={props.sx}
      >
        {capitalize(label)}
      </Button>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: "primary",
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      )}
    </Box>
  );
};